import styles from "./EmailLink.module.css";

type Props = {
  user: string;
  domain: string;
  label?: string;
  className?: string; // ✅ erlauben
};

export default function EmailLink({ user, domain, label, className }: Props) {
  const shown = label ?? `${user} (at) ${domain}`;

  const handleClick = () => {
    window.location.href = `mailto:${user}@${domain}`;
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={[styles.linkLike, className].filter(Boolean).join(" ")} // ✅ Module + optional extra
      aria-label={`E-Mail an ${user}@${domain} schreiben`}
    >
      {shown}
    </button>
  );
}